export const invertedMessages = {
  'No data available': 'CERTS_NO_DATA_AVAILABLE',
  'Got It': 'CERTS_SAVI_GOT_IT',
  'Access provided Outside of Saviynt': 'TM.OOB.Unsure.label',
  'Access provided from Saviynt': 'TM.OOB.label',
  'Certified within last 3 months': 'TM.LastCert.Less3months.label',
  'Certified within last 6 months':
    'TM.LastCert.Greater3monthsAndLess6months.label',
  'Certified within last 9 months':
    'TM.LastCert.Greater6monthsAndLess9months.label',
  'Certified within last year':
    'TM.LastCert.Greater9monthsAndLess12months.label',
  'Certified more than an year ago': 'TM.LastCert.0monthsDiff.label',
  'Data not available for last certified': 'TM.LastCert.Unsure.label',
  '{0} Confidence of Peer Access': 'TM.PAA.label',
  'Data not available to calculate Peer Access Confidence':
    'TM.PAA.NoData.Unsure.label',
  'Data not available for Sox Criticality': 'TM.SOX.Unsure.label',
  'Very High SOX Criticality': 'TM.SOX.VeryHigh.label',
  'High SOX Criticality': 'TM.SOX.High.label',
  'Medium SOX Criticality': 'TM.SOX.Medium.label',
  'Low SOX Criticality': 'TM.SOX.Low.label',
  'Very Low SOX Criticality': 'TM.SOX.VeryLow.label',
  'No SOD found for this Entitlement': 'TM.SOD.NoEntitlement.label',
  'Mitigated Low SOD Risk': 'TM.SOD.MitigatedLowRisk.label',
  'Mitigated Medium SOD Risk': 'TM.SOX.MitigatedMediumRisk.label',
  'Mitigated High SOD Risk': 'TM.SOD.MitigatedHighRisk.label',
  'Mitigated Critical SOD Risk': 'TM.SOD.MitigatedCriticalRisk.label',
  'Open Low SOD Risk': 'TM.SOX.OpenLowRisk.label',
  'Open Medium SOD Risk': 'TM.SOX.OpenMediumRisk.label',
  'Open High SOD Risk': 'TM.SOX.OpenHighRisk.label',
  'Open Critical SOD Risk': 'TM.SOX.OpenCriticalRisk.label',
  'Data not available for SOD Risk': 'TM.SOD.DataNotAvailable.label',
  'Role Access available beyond Enddate': 'TM.RUA.BeyondEndDate.beyond.label',
  'Role Access available within Enddate': 'TM.RUA.BeyondEndDate.within.label',
  'Role Access Composition score is {0}': 'TM.RUA.RAC.minscore.label',
  'Role Access Composition score is not available': 'TM.RUA.RAC.nodata.label',
};
